/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/data/GetInvalidPathChars.ts
 * @create:      2025-07-01 18:01:32.376
 * @modify:      2025-07-11 21:19:12.968
 * @version:     6.0.0
 * @times:       9
 * @lines:       50
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ArrayDistinct } from "../array/ArrayDistinct";
import { GetInvalidPathCharsWindows } from "./GetInvalidPathCharsWindows";
import { GetInvalidPathCharsUnix } from "./GetInvalidPathCharsUnix";

/**
 * Returns an array of characters that are considered invalid in file paths
 * across both Unix and Windows operating systems. The resulting array contains
 * only distinct characters.
 *
 * @returns {string[]} An array of unique invalid path characters.
 * 
 * @since 4.0.0
 * @version 2021-12-09
 */
export function GetInvalidPathChars(): string[] {
    return ArrayDistinct(GetInvalidPathCharsUnix().concat(GetInvalidPathCharsWindows()));
}
